export const createDomainRequest = (data, cancelToken) => (dispatch, getState, api) =>
  api({
    method: 'post',
    apiPath: 'domain-requests',
    data,
    cancelToken
  });

export const createDomainRequestAttempt = (data, cancelToken) => (dispatch, getState, api) =>
  api({
    method: 'post',
    apiPath: 'domain-request-attempts',
    data,
    cancelToken
  });



// WEBPACK FOOTER //
// ./src/actions/domainRequest.js